export default __webpack_public_path__ + "static/media/plus.d673ab1f.svg";